import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { ImportPayload } from "src/app/_models/Import/ImportModel";
import { ImportActionTypes } from "src/app/constants/StoreConstants";
import { ImportStatus } from "./import.state";

export const UploadCSV = createAction(
  ImportActionTypes.UploadCSV,
  props<{payload: ImportPayload}>()
);

export const UploadTutorCSV = createAction(
  ImportActionTypes.UploadTutorCSV,
  props<{payload: ImportPayload}>()
);

export const UploadCSVSuccess = createAction(
  ImportActionTypes.UploadCSVSuccess,
  props<{result: boolean}>()
);

export const UploadCSVError = createAction(
  ImportActionTypes.UploadCSVError,
  props<{error: HttpErrorResponse}>()
);

export const GetImportStatusSuccess = createAction(
  ImportActionTypes.GetImportStatusSuccess,
  props<{result: ImportStatus}>()
);

export const GetImportStatusError = createAction(
  ImportActionTypes.GetImportStatusError,
  props<{error: HttpErrorResponse}>()
);

export const CloseImportStatus = createAction(
  ImportActionTypes.CloseImportStatus
);

export const AuthorizeSSE = createAction(
  ImportActionTypes.AuthorizedSSE
);

export const AuthorizeSSESuccess = createAction(
  ImportActionTypes.AuthorizedSSESuccess,
  props<{result: boolean}>()
);

export const AuthorizeSSEError = createAction(
  ImportActionTypes.AuthorizedSSEError,
  props<{error: HttpErrorResponse}>()
);

export const ResetImportState = createAction(
  ImportActionTypes.ResetImportStatus
);

export const DownloadErrorList = createAction(
  ImportActionTypes.DownloadErrorList
);

export const DownloadErrorTutorList = createAction(
  ImportActionTypes.DownloadErrorTutorList
);

export const DownloadErrorListSuccess = createAction(
  ImportActionTypes.DownloadErrorListSuccess,
  props<{result: string[]}>()
);

export const DownloadErrorListError = createAction(
  ImportActionTypes.DownloadErrorListError,
  props<{error: HttpErrorResponse}>()
);

export const HasImport = createAction(
  ImportActionTypes.HasImport
);

export const HasImportTutor = createAction(
  ImportActionTypes.HasImportTutor
);

export const HasImportSuccess = createAction(
  ImportActionTypes.HasImportSuccess,
  props<{result: number}>()
);

export const HasImportError = createAction(
  ImportActionTypes.HasImportError,
  props<{error: HttpErrorResponse}>()
);

export const ClearImportSession = createAction(
  ImportActionTypes.ClearImportSession
);

export const ClearImportTutorSession = createAction(
  ImportActionTypes.ClearImportTutorSession
);

export const ClearImportSessionSuccess = createAction(
  ImportActionTypes.ClearImportSessionSuccess
);

export const ClearImportSessionResult = createAction(
  ImportActionTypes.ClearImportSessionResult,
  props<{result: boolean}>()
);

export const CancelImport = createAction(
  ImportActionTypes.CancelImport
);

export const CancelImportTutor = createAction(
  ImportActionTypes.CancelImportTutor
);

export const CancelImportSuccess = createAction(
  ImportActionTypes.CancelImportSuccess
);

export const CancelImportError = createAction(
  ImportActionTypes.CancelImportError
);